// ──────────────────────────────────────────────────────
// Shared input normalization utilities
// Used by both kiosk scan flows and admin search.
// ──────────────────────────────────────────────────────

/**
 * Normalize Arabic-Indic (٠–٩) and Eastern/Persian (۰–۹) digits to ASCII 0-9.
 * Essential for Arabic-first kiosk environments where keyboard layout
 * may inject non-ASCII digit codepoints.
 */
export function normalizeDigits(s: string): string {
    return s.replace(/[\u0660-\u0669\u06F0-\u06F9]/g, (ch) => {
        const code = ch.charCodeAt(0);
        return String(code <= 0x0669 ? code - 0x0660 : code - 0x06F0);
    });
}
